import { TFunction } from "i18next";

import {
    PULL_REGISTRATION_TOKEN_GONE,
    SCOPE_TOKEN_ALREADY_USED,
    SCOPE_TOKEN_EXPIRED,
    TIME_ERROR,
    URL_EXPIRED,
} from "@/shared/errors";

export const getErrorMarkup = (t: TFunction, errorCode: string): string => {
    let errorInfo;
    // Edge case
    if (errorCode === PULL_REGISTRATION_TOKEN_GONE) {
        errorInfo = t("Errors.Code", {
            context: errorCode?.toString(),
            currentUrl: location.origin,
        });
    } else {
        errorInfo = t("Errors.Code", { context: errorCode?.toString() });
    }

    if (errorInfo.includes("Errors.Code")) {
        errorInfo = t("Errors.Code"); // fallback
    }
    return errorInfo;
};

export const isWarning = (errorCode: string): boolean => {
    return (
        errorCode === URL_EXPIRED ||
        errorCode === TIME_ERROR ||
        errorCode === SCOPE_TOKEN_EXPIRED ||
        errorCode === SCOPE_TOKEN_ALREADY_USED
    );
};
